import React, { useEffect, useState } from 'react';
import { FaChevronUp } from 'react-icons/fa';

function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 360);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const goTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      className={`eduya-back-top${visible ? ' is-visible' : ''}`}
      aria-label="Back to top"
      onClick={goTop}
    >
      <FaChevronUp />
    </button>
  );
}

export default BackToTop;
